import { type AnalyticsEvent } from '@backstage/core-plugin-api';
import { type MetricRequest } from '@internal/plugin-neo4j-analytics-common';

import { BaseAnalyticsEventHandler } from './types';

export class NavigateEventHandler extends BaseAnalyticsEventHandler {
  readonly eventName = 'navigate';
  readonly metricName = 'navigation';

  canHandle(action: string): boolean {
    return action === this.eventName;
  }

  handle(event: AnalyticsEvent): MetricRequest[] {
    if (!this.canHandle(event.action)) {
      return [];
    }

    const name = this.getMetricName(this.metricName);
    const depth = event.subject.split('/').filter(Boolean).length;

    return [
      {
        kind: 'counter',
        name: `${name}`,
        value: 1,
        attributes: {
          plugin: event.context.pluginId,
          to: event.subject,
        },
        options: {
          description: 'Total number of navigations',
          unit: '1',
          valueType: 'int',
        },
      },
      {
        kind: 'histogram',
        name: `${name}.depth`,
        value: depth,
        attributes: {
          plugin: event.context.pluginId,
        },
        options: {
          description: 'Histogram of navigation depth',
          unit: '1',
          valueType: 'int',
          advice: {
            explicitBucketBoundaries: [1, 3, 5, 10],
          },
        },
      },
    ];
  }
}
